import React from 'react';
import { Linkedin } from 'lucide-react';
import { aboutData } from '../data/mock';

const About = () => {
  return (
    <section id="sobre-mi" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Image */}
            <div className="relative">
              <div className="relative z-10">
                <img
                  src={aboutData.image}
                  alt={aboutData.name}
                  className="w-full rounded-2xl shadow-2xl"
                />
              </div>
              {/* Decorative elements */}
              <div className="absolute -bottom-6 -right-6 w-full h-full border-4 border-[#00E5A3] rounded-2xl -z-0" />
              <div className="absolute -top-6 -left-6 w-32 h-32 bg-[#013139] rounded-full opacity-10" />
            </div>

            {/* Content */}
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#013139] mb-4">
                Sobre mí
              </h2>
              <h3 className="text-2xl md:text-3xl font-bold text-[#013139] mb-2">
                {aboutData.name}
              </h3>
              <p className="text-lg text-[#00E5A3] font-semibold mb-6">
                CEO y fundador de FluenceIA
              </p>
              <p className="text-base text-gray-600 italic mb-6">
                {aboutData.title}
              </p>

              <p className="text-lg text-gray-700 mb-4 leading-relaxed font-medium">
                {aboutData.description}
              </p>

              {aboutData.story.map((paragraph, index) => (
                <p key={index} className="text-gray-600 mb-4 leading-relaxed">
                  {paragraph}
                </p>
              ))}

              {/* Stats */}
              <div className="grid grid-cols-3 gap-6 mt-8 pt-8 border-t-2 border-gray-200">
                {aboutData.stats.map((stat, index) => (
                  <div key={index} className="text-center">
                    <div className="text-3xl md:text-4xl font-bold text-[#00E5A3] mb-2">
                      {stat.number}
                    </div>
                    <div className="text-sm text-gray-600">
                      {stat.label}
                    </div>
                  </div>
                ))}
              </div>

              {/* LinkedIn Button */}
              <div className="mt-8">
                <a
                  href="https://www.linkedin.com/in/emilio-s%C3%A1ez-yebra-1b65b8164/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-[#0077B5] hover:bg-[#006399] text-white font-semibold rounded-lg transition-colors"
                >
                  <Linkedin size={20} />
                  Conéctate en LinkedIn
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
